export default __webpack_public_path__ + "static/media/latest-news-img19.9f2a52de.jpg";